export default __webpack_public_path__ + "09ae22cd8481bb1adbca82222ba8cde8.jpg";